export const KEYBOARD_KEYS = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
};

export const TILE_BORDER_WIDTHS = [0, 1, 2, 3, 4, 5];

export const SPACING_INTERVALS = [{ minimum: 0, maximum: 35, step: 1 }];

export const ROUNDING_INTERVALS = [{ minimum: 0, maximum: 14, step: 1 }];
